export default {
    watch: {
        filter: {
            handler(newVal) {
                const name = this.$cache.active || this.$route.name
                this.$cache[name] = Object.assign({}, newVal)
            },
            deep: true
        }
    }
}